import React, { useEffect } from 'react'
import { Row, Col, message } from 'antd'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { contexts } from '@/domains'
import { globalStore } from '@/GlobalStore'

import '@/styles/pages/join.less'
import { JoinConfig } from './Config'

const { GlobalContext } = contexts

const joinCardStyle = {
  width: JoinConfig.cardWidthPx,
  height: JoinConfig.cardHeightPx,
} as const

const Join = () => {
  const navigate = useNavigate()
  const { getUserInfo, userInfo } = GlobalContext.useContainer()
  useEffect(() => {
    const userId = userInfo?.id
    if (!userId) {
      return
    }
    void (async () => {
      const res = await getUserInfo(userId)
      if (res?.teamList?.length) {
        globalStore.syncCurrentTeamFromUser()
        await globalStore.loadTeamData()
        navigate('/home')
      }
    })()
  }, [userInfo?.id, getUserInfo, navigate])
  return (
    <div className="sparrow-wrap join">
      <Row className="sparrow-inner">
        <Col span={12}>
          {/* 左侧内容 */}
          <h1 style={{ fontSize: JoinConfig.headingFontSizePx }}>
            第一次使用麻雀系统? 你可以:
          </h1>
          <a
            className="join-btn"
            href="javascript:;"
            style={joinCardStyle}
            onClick={() => {
              message.info('请联系团队/企业管理员添加自己到组织中', 2)
            }}
          >
            <img
              src="https://access-wfile.yuanling.com/yl-static/join-team.png"
              alt=""
              style={{ height: JoinConfig.cardHeightPx }}
            />
            <div style={{ fontSize: JoinConfig.cardTitleFontSizePx }}>
              加入一个已有的团队/企业
              <span style={{ fontSize: JoinConfig.cardSubtitleFontSizePx }}>
                联系团队/企业管理员添加自己到组织中
              </span>
            </div>
          </a>
          <a
            className="join-btn"
            target="_blank"
            rel="noreferrer"
            href="https://www.superthem.com/renwu/detail?id=41843697125941248"
            style={joinCardStyle}
          >
            <img
              src="https://access-wfile.yuanling.com/yl-static/create-team.png"
              alt=""
              style={{ height: JoinConfig.cardHeightPx }}
            />
            <div style={{ fontSize: JoinConfig.cardTitleFontSizePx }}>
              创建一个个人团队
              <span style={{ fontSize: JoinConfig.cardSubtitleFontSizePx }}>
                适用于自由职业者组成的5人以下的小团队
              </span>
            </div>
          </a>
          <a
            className="join-btn"
            target="_blank"
            rel="noreferrer"
            href="https://www.superthem.com/renwu/detail?id=41843697125941248"
            style={joinCardStyle}
          >
            <img
              src="https://access-wfile.yuanling.com/yl-static/create-comp.png"
              alt=""
              style={{ height: JoinConfig.cardHeightPx }}
            />
            <div style={{ fontSize: JoinConfig.cardTitleFontSizePx }}>
              创建一个企业
              <span style={{ fontSize: JoinConfig.cardSubtitleFontSizePx }}>
                适用于超过5人以上的企业
              </span>
            </div>
          </a>
        </Col>
        <Col span={12}>
          <img
            src="https://access-wfile.yuanling.com/yl-static/sparrow-join-banner.png"
            alt=""
          />
          <p className='join-banner-text'>根据实践反馈，相比传统坐班团队，使用麻雀系统的远程团队效率普遍提升了至少1.5倍!</p>
        </Col>
      </Row>
    </div>
  )
}

export default observer(Join)
